
import { computed, defineComponent, onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";

import { TodoSupport } from "@/store/pinia/TodoSupport";
import { storeToRefs } from "pinia";
import ApiService from "@/core/services/ApiService";
import { Mutations } from "@/store/enums/StoreEnums";
import { useStore } from "vuex";

export default defineComponent({
  name: "todo-category-list",
  setup() {
    const { t, te } = useI18n();
    const translate = (text) => {
      if (te(text)) return t(text);
      return text;
    };

    const BoardName = ref();
    const EditBoardName = ref();

    const store = useStore();

    const TodoSupportHolder = TodoSupport();
    const {
      fetchTodosCategory,
      fetchBoard,
      deleteBoard,
      editBoard,
      storeBoard,
    } = TodoSupportHolder;

    const {
      categories,
      loadingCategory,
      activeBoardId,
      boardsList,
      activeBoardInfo,
    } = storeToRefs(TodoSupportHolder);

    onMounted(() => {
      fetchBoard();
      if (!categories.value) fetchTodosCategory();
      // if (categories.value) categories.value = categories;
    });

    const add = () => {
      categories.value.push({
        id: null,
        name: "",
        sort: categories.value.length + 1,
      });
    };

    const create = (index) => {
      ApiService.post("admin/support/task-category/create", {
        name: categories.value[index].name,
        sort: categories.value[index].sort,
        board_id: activeBoardId.value,
      })
        .then(() => {
          fetchTodosCategory();
        })
        .catch(({ response }) => {
          if (response && response.data)
            store.commit(Mutations.SET_ERROR, response.data);
        });
    };

    const update = (index) => {
      ApiService.post(
        `admin/support/task-category/${categories.value[index].id}/edit`,
        {
          name: categories.value[index].name,
          sort: categories.value[index].sort,
          board_id: activeBoardId.value,
        }
      )
        .then(() => {
          fetchTodosCategory();
        })
        .catch(({ response }) => {
          if (response && response.data)
            store.commit(Mutations.SET_ERROR, response.data);
        });
    };

    const deleteCat = (id) => {
      ApiService.post(`admin/support/task-category/${id}/delete`, {})
        .then(() => {
          fetchTodosCategory();
        })
        .catch(({ response }) => {
          if (response && response.data)
            store.commit(Mutations.SET_ERROR, response.data);
        });
    };

    const remove = (index) => {
      categories.value = categories.value.filter((item, j) => j !== index);
    };

    const disabledAdd = computed(() => {
      if (!categories.value) return false;
      let find = categories.value.filter((item) => item.id === null);
      return find.length > 0;
    });

    const submitCreateBoard = ref<HTMLButtonElement | null>(null);
    const createBoard = () => {
      if (submitCreateBoard.value) {
        submitCreateBoard.value!.disabled = true;
        submitCreateBoard.value.setAttribute("data-kt-indicator", "on");
      }

      storeBoard({
        title: BoardName.value,
      });

      setTimeout(() => {
        if (submitCreateBoard.value) {
          submitCreateBoard.value?.removeAttribute("data-kt-indicator");
          submitCreateBoard.value!.disabled = false;
        }
      }, 5000);
    };

    const submitEditBoard = ref<HTMLButtonElement | null>(null);
    const editBoardFunc = () => {
      if (submitEditBoard.value) {
        submitEditBoard.value!.disabled = true;
        submitEditBoard.value.setAttribute("data-kt-indicator", "on");
      }

      editBoard(activeBoardId.value, {
        title: EditBoardName.value,
      });

      setTimeout(() => {
        if (submitEditBoard.value) {
          submitEditBoard.value?.removeAttribute("data-kt-indicator");
          submitEditBoard.value!.disabled = false;
        }
      }, 5000);
    };

    return {
      translate,

      add,
      create,
      deleteCat,
      remove,
      createBoard,
      categories,
      update,
      disabledAdd,
      loadingCategory,

      submitEditBoard,
      submitCreateBoard,
      BoardName,
      EditBoardName,
      editBoardFunc,
      boardsList,
      activeBoardInfo,
      activeBoardId,
      deleteBoard,
    };
  },
});
